module.exports = __webpack_public_path__ + "img/SketchPnge3a1071ad23644845f66dc84e7cbfa6e0a0c201713eebcb2dac64a7c5b0e42f6.c4d5e269.png";